import React from "react";
import { NewAppointmentModal } from "../newAppointmentModal.tsx";
import { AppointmentsType } from "../dto.ts";

export function AppointmentsModal() {
    const appointmentComponentMap: Record<AppointmentsType, React.FC<any>> = {
        [AppointmentsType.appointents]: NewAppointmentModal,
    };

    const Component = appointmentComponentMap[AppointmentsType.appointents];
    return <Component />;
}